"use client";

import Image from "next/image";
import { useTheme } from "next-themes";

export default function WarpBuildLogo() {
  const { resolvedTheme } = useTheme();
  const logoSrc =
    resolvedTheme === "dark"
      ? "/brand-assets/warpbuild-logo-dark.svg"
      : "/brand-assets/warpbuild-logo-light.svg";

  return <Image src={logoSrc} alt="WarpBuild Logo" height={24} width={24} />;
}
